import { defineComponent as _defineComponent } from 'vue'
import LoadingGif from "../loading/LoadingGif.vue";
import TableauSelectButton from "./TableauSelectButton.vue";
import { computed, onMounted, ref, watch } from "vue";

interface Props {
  placeholder?: string;
  getItems: () => Promise<{ id: string; text: string }[]>;
  modelValue?: string[];
  multiSelect?: boolean;
  disabled?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TableauSelect',
  props: {
    placeholder: { type: String, required: false },
    getItems: { type: Function, required: true },
    modelValue: { type: Array, required: false },
    multiSelect: { type: Boolean, required: false },
    disabled: { type: Boolean, required: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: emits }) {

const props = __props;



const itemsLoadStatus = ref<"loading" | "success" | "error">("loading");
const items = ref<{ id: string; text: string }[]>([]);
const selectedItems = ref<{ id: string; text: string }[]>([]);
const buttonInstance = ref<HTMLButtonElement | null>(null);
// the kind of text on the button
const buttonTextKind = computed<"stmplaceholder" | "loading" | "error" | "value">(() => {
  switch (itemsLoadStatus.value) {
    case "loading":
      return "loading";
    case "error":
      return "error";
  }
  const i = selectedItems.value || [];
  if (i.length === 0) {
    return "stmplaceholder";
  } else {
    return "value";
  }
});
// the text itself
const buttonText = computed(() => {
  switch (buttonTextKind.value) {
    case "stmplaceholder":
      return props.placeholder;
    case "loading":
      return "Loading...";
    case "error":
      return "Failed to load items";
    case "value":
      if ((selectedItems.value || []).length === 1) {
        return selectedItems.value[0].text;
      } else {
        return `${selectedItems.value.length} selected`;
      }
  }
});
const buttonDisabled = computed(
  () =>
    props.disabled ||
    buttonTextKind.value === "loading" ||
    buttonTextKind.value === "error"
);
// when the component mounts, retrieve and display the items
onMounted(async () => {
  await loadItems();
});

async function loadItems() {
  itemsLoadStatus.value = "loading";
  try {
    items.value = await props.getItems();
    itemsLoadStatus.value = "success";
    const initialIds = props.modelValue || [];
    if (initialIds.length > 0) {
      selectedItems.value = initialIds
        .map((id: string) => items.value.find((e) => e.id === id))
        .filter((e: { id: string; text: string } | undefined) => !!e)
        .map((e: { id: string; text: string } | undefined) => e!);
    }
  } catch (e) {
    itemsLoadStatus.value = "error";
  }
}

const menuOpen = ref(false);
const overlayStyle = ref({ left: "0px", top: "0px", width: "0px" });
function toggleOpen() {
  setOpen(!menuOpen.value);
}
function backdropClicked() {
  setOpen(false);
}
function overlayClicked() {
  if (props.multiSelect) {
    return;
  }
  setOpen(false);
}
function setOpen(open: boolean) {
  menuOpen.value = open;
  if (menuOpen.value) {
    const rect = buttonInstance.value!.getBoundingClientRect();
    overlayStyle.value = {
      left: `${rect.left}px`,
      top: `${rect.bottom}px`,
      width: `${rect.width}px`,
    };
  }
}
function itemClicked(item: { id: string; text: string }) {
  if (!props.multiSelect) {
    selectedItems.value = [item];
  } else {
    const existingIndex = selectedItems.value.findIndex((e) => e.id === item.id);
    if (existingIndex === -1) {
      selectedItems.value.push(item);
    } else {
      selectedItems.value.splice(existingIndex, 1);
    }
  }
  emits(
    "update:modelValue",
    selectedItems.value.map((e) => e.id)
  );
}
__expose({
  loadItems,
});

const __returned__ = { props, emits, itemsLoadStatus, items, selectedItems, buttonInstance, buttonTextKind, buttonText, buttonDisabled, loadItems, menuOpen, overlayStyle, toggleOpen, backdropClicked, overlayClicked, setOpen, itemClicked, LoadingGif, TableauSelectButton }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})